import Vue from 'vue'
import App from './App.vue'
import Vuelidate from 'vuelidate'
import router from './router/router.js'
import store from "@/store"
import VueNotification from '@kugatsu/vuenotification'
import VModal from 'vue-js-modal'
import Swiper, { Navigation, Pagination } from 'swiper'
import CKEditor from '@ckeditor/ckeditor5-vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSocialAuth from 'vue-social-auth'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import './axios';

Swiper.use([Navigation, Pagination]);

Vue.use(Vuelidate)
Vue.prototype.$store = store;
Vue.use(VueNotification, {
    success: {
        background: "green",
        color: "white"
    }
});
Vue.use(VModal, { dialog: true })
Vue.use(CKEditor);
Vue.use(VueAxios,axios);
Vue.use(VueSocialAuth, {
    providers: {
        facebook: {
            clientId: process.env.VUE_APP_CLIENTID,
            redirectUri: process.env.VUE_APP_REDIRECT_URL // Your client app URL
        }
    }
});
Vue.use(VueAwesomeSwiper)

Vue.filter('format_number', function (value) {
  if (value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return value;
  }
});

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
